import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen } from 'lucide-react';
const fadeIn = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function BlogHero() {
  return <section className="relative pt-24 pb-32 px-4 overflow-hidden" data-id="element-295">
      <div className="absolute inset-0 z-0" data-id="element-296">
        <img src="https://cdn.magicpatterns.com/uploads/vzPZ8uHF3JtrQB3XqPFd71/Blog_bg.jpg" alt="Blog Hero" className="w-full h-full object-cover object-top" data-id="element-297" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0f1f3d]/90 via-[#0f1f3d]/80 to-[#0f1f3d]/90" data-id="element-298"></div>
      </div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-299">
        <motion.div initial="hidden" animate="visible" variants={fadeIn} className="space-y-6" data-id="element-300">
          <div className="flex items-center justify-center gap-3 mb-4" data-id="element-301">
            <BookOpen className="w-10 h-10 text-[#a3d977]" data-id="element-302" />
          </div>
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-black text-white leading-tight tracking-tight drop-shadow-2xl" data-id="element-303">
            Blog
          </h1>
          <div className="w-24 h-1 bg-[#a3d977] mx-auto rounded-full mb-6" data-id="element-304"></div>
          <p className="text-lg sm:text-xl text-white/95 max-w-3xl mx-auto leading-relaxed drop-shadow-lg" data-id="element-305">
            Tips, insights, and stories from the NWBBA community
          </p>
        </motion.div>
      </div>
    </section>;
}